import { VolumeChart, type VolumeChartData } from '@revelio/replots';

import { usePlotMetric } from '../../hooks/usePlotMetric';
import type { TimeseriesDataSet } from '../DataProvider/types';
import { useChart } from './ChartProvider';
import { SharableChart } from './chart-menu/plot-share/SharableChart';
import { getFormat } from './utils/getFormat';

export const Volume = ({ data }: { data: TimeseriesDataSet['data'] }) => {
  const { item } = useChart();
  const metric = usePlotMetric();
  const color = item?.plot?.color;
  const format = item?.plot?.format ?? getFormat({ metric });

  const volumeData: VolumeChartData[] = data.map((item, i) => {
    const id = (() => {
      if (i === 0) return 'active';
      if (i === 1) return 'new';
      if (i === 2) return 'removed';
      return '';
    })();
    return {
      id,
      label: item.dim,
      values: item.timeseries.map((timePoint) => ({
        date: timePoint.date,
        value: timePoint.value ?? 0,
      })),
    };
  });

  return (
    <SharableChart
      Component={VolumeChart}
      data={volumeData}
      color={color}
      format={format}
      fontSize={item?.plot?.fontSize}
    />
  );
};
